export default "/_next/static/assets/fonts/GoodOT-Regular.337482c94ac23b0a27d9a4ae9fc3d9f9.woff2";